export const USER_CONSENT_KEY = "user_consent";
